import $ from 'jquery';

const $menuIcon = $('.js-sidebar-open'),
		$openLogin = $('#js-open-login'),
		$header = $('.header');

$menuIcon.click(function() {
	$header.hasClass('open-sidebar') ? $header.removeClass('open-sidebar') && setTimeout(function() {$header.removeClass('open-nav open-login')}, 250) : 
	
		$(this).hasClass('header__menu') ? $header.addClass('open-sidebar open-nav') && setTimeout(function() {$header.removeClass('open-login')}, 250) : 
			
			$header.addClass('open-sidebar open-login') && setTimeout(function(){$header.removeClass('open-nav')},250);
});


$openLogin.click(function(){
	$header.removeClass('open-nav');
	$header.addClass('open-login');
});



// WEBPACK FOOTER //
// ./app/src/assets/js/partials/sidebar.js